export const developBranchName = (): string | null => {
  if (typeof window !== 'undefined') return window.envs?.developBranchName
  return null
}
